export const selectionReportId = 6;
export const frequencyReportId = 10;

export const defaultIntervalValue = 10;

export const adjustToFiltersOptionValue = 0;

export const reportLayoutTypeContext = 1;

export const selectionReportTranslations = {
  selection_report_extend_btn: 7741,
  aggregation_area_title: 7732,
  aggregation_field_info: 7733,
  aggregation_btn_open_dialog: 7734,
  aggregation_dialog_title: 3560,
  aggregation_done: 7338,
  aggregation_drag_n_drop: 7740,
  aggregation_remove: 7742,
  aggregation_search: 7345,
  aggregation_how_to_aggregate: 7963,
  aggregation_unit_of_measure_set: 8553,

  distribution_title: 7924,
  distribution_area_title: 7881,
  distribution_field_info: 7733,
  distribution_btn_open_dialog: 7734,
  distribution_dialog_title: 3560,
  distribution_done: 7338,
  distribution_drag_n_drop: 7740,
  distribution_remove: 7742,
  distribution_search: 7345,
  distribution_for_every: 7919,
  distribution_percent_inrease: 7920,

  group_by_title: 7923,
  group_by_area_title: 7736,
  group_by_btn_open_dialog: 7737,
  group_by_dialog_title: 3560,
  group_by_done: 7338,
  group_by_confirm: 7739,
  group_by_drag_n_drop_panel: 7740,
  group_by_remove: 7742,
  group_by_move_up: 7743,
  group_by_move_down: 7538,
  group_by_search: 7345,
  group_by_adjust_to_filters: 7751,
  group_by_level: 3619,
  group_by_rolling_average: 7815,
  group_by_show_missing_values: 7822,
  group_by_hide_missing_values: 7821,
  group_by_missing_values_are_included: 7820,
  group_by_interval_value_not_valid: 7951,
  group_by_limit_to_category: 7962,
  group_by_sort: 8032,

  target_title: 7925,
  target_area_title: 7763,
  target_btn_open_dialog: 7764,
  target_dialog_title: 3560,
  target_done: 7338,
  target_drag_n_drop: 7740,
  target_remove: 7742,
  target_search: 7345,

  toggle_info_description: 7759,
  toggle_info_subtitle: 7760,
  toggle_info_title: 7761,
  toggle_info_load_options: 7762,  
  execute_failed_info_description: 8331,

  result_cannnot_be_displayed: 7789,
  choose_chart_type_limit_message_singular: 7791,
  choose_chart_type_limit_message_plural: 7790,
  drill_down_to: 9158,
  drill_down_to_done: 7338,
  drill_down_to_info: 9160,

  // selection layout translations
  favourite_unsupported_presentation_type: 7478,
  favourite_not_present_type_favourite: 7483,
  chart_not_supported_type: 7484,
  no_search_result: 6778,
  show_details: 7640,
  hide_details: 7641,
  column_chart_percentage_warning: 9069,
  average_minimum_maximum_warning: 9099,
  days_since_aggr_warning: 9100,
  rolling_average_warning: 9101,
  target_warning: 9102,
  frequency_report_percent_warning: 9103,
  area_chart_uom_warning: 9196,

  // layout attributes translations
  attribute_field_labels: 7984,
  attribute_quantities: 7983,
  attribute_groups: 7982,
  attribute_wide_layout: 7981,
  attribute_totals: 7980,
  attribute_suppress_repeating_rows: 7979,
  attribute_xAxis_labels_enabled: 8030,
  attribute_yAxis_labels_enabled: 8029,
  attribute_show_value: 9058,
  attribute_show_percent: 9059,
  attribute_hide_datalabels_on_dashboards: 9060,
  attribute_stacked: 9067,
  attribute_percent: 9068,
  attribute_donut_view: 9079,
  attribute_semi_circle_view: 9080
};
